import { ErrorBase } from './error.base';

export class ErrorHttp extends ErrorBase {

    constructor(status: number, name: string, message: string) {
        super(name, message);

        this.status = status;
    }

    public status?: number = null;

}
